export function editing(store, {editing}) {
	store.editing = editing
}

export function showSettings(store, show) {
	store.showingSettings = show
}

export function showTitle(store, show) {
	store.showimgTitles = show
	console.log(store.showimgTitles)
}